import PropTypes from "prop-types"
import { useMemo } from "react"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"

import { usePopupTrigger } from "areas/footer/jewlr/footer-subscribe"
import Button from "components/ui/button"
import { cn } from "styles/utils"

const getComponents = (defaultClassName, classNames, triggerPopup) => ({
  a: ({ href, ...props }) => (
    <Button
      asChild
      className={cn(defaultClassName, classNames?.anchorClassName)}
      text
      underline
    >
      <Link data-lc="countdown-banner" to={href} {...props} />
    </Button>
  ),
  p: ({ ...props }) => (
    <p
      className={cn("inline", defaultClassName, classNames?.paragraphClassName)}
      {...props}
    />
  ),
  ...(triggerPopup && {
    code: (props) => (
      <Button
        className={cn(defaultClassName, classNames?.anchorClassName)}
        onClick={triggerPopup}
        text
        underline
        {...props}
      />
    ),
  }),
})

const MicroBannerMarkdown = ({
  children,
  classNames,
  defaultClassName,
  type,
}) => {
  const triggerPopup = ["sign-up", "sign-up-countdown"].includes(type)
    ? usePopupTrigger()
    : null
  const components = useMemo(
    () => getComponents(defaultClassName, classNames, triggerPopup),
    [defaultClassName, classNames, triggerPopup]
  )
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    supressHydrationWarning: true,
  })

  return markdownContent
}

MicroBannerMarkdown.propTypes = {
  children: PropTypes.string,
  classNames: PropTypes.object,
  defaultClassName: PropTypes.string,
  type: PropTypes.string,
}

export default MicroBannerMarkdown
